import React, { Component, createRef } from "react";

import { Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  getPartyApi,
  getUnitAPI,
  getUserByRoleId,
  updateStockInward,
} from "api";

class UserEditInwardStock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...this.props,
      validation: "",
      props: props?.location?.query
        ? props.location.query
        : { isEdit: false, data: null },
      partyList: [],
      factoryList: [],
      deliveryBoyList: [],
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
  }

  async handleSubmit(e, values) {
    e.preventDefault();
    if (this.state.props.isEdit == true) {
      values.weightType = "CT";
      delete values.party,
        delete values.createdAt,
        delete values.cycle,
        delete values.factory,
        delete values.fromDeliverBoy,
        delete values.status,
        delete values.toDeliverBoy,
        delete values.updatedAt,
        delete values.user,
        delete values.userId;
      const data = await updateStockInward(values);
      this.state.history.push("/user-office-stock-list");
    }
  }

  async componentDidMount() {
    const party = await getPartyApi({
      page: null,
      limit: null,
      name: null,
      partyCode: null,
    });
    if (party && party.data) {
      this.setState({
        partyList: party.data.parties,
      });
    }
    const factory = await getUnitAPI({ isInternal: true });
    if (factory && factory.data) {
      this.setState({
        factoryList: factory.data.factories,
      });
    }
    const deliveryBoy = await getUserByRoleId("ROLE0000006");
    if (deliveryBoy && deliveryBoy.data) {
      this.setState({
        deliveryBoyList: deliveryBoy.data.users,
      });
    }
  }

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    //meta title
    document.title = "sales-office";
    const { validation } = this.state;
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs
              breadcrumbItem={`${this.props.t("MANAGE STOCK - INWARD")}`}
            />
            <Row>
              <Col xl="12">
                <Card>
                  <CardBody>
                    <div className="d-lg-flex d-block justify-content-between">
                      <div>
                        {this.state.props.isView ? (
                          <h4 className="pb-3 text-black fw-bold">
                            View Stock (Inward)
                          </h4>
                        ) : (
                          <h4 className="pb-3 text-black fw-bold">
                            {this.props.t("Edit Stock (Inward)")}
                          </h4>
                        )}
                      </div>
                      {/* <div>
                        <label
                          htmlFor="date"
                          className="pe-2 fs-5 fw-bold text-black"
                        >
                          Date:
                        </label>
                        <input
                          type="date"
                          className="fs-5 border-0 text-black"
                        />
                      </div> */}
                    </div>
                    <Formik
                      enableReinitialize={true}
                      initialValues={this.state.props.data}
                      validationSchema={Yup.object().shape({
                        partyId: Yup.string().required(
                          "This Value is Required"
                        ),
                        factoryId: Yup.string().required(
                          "This Value is Required"
                        ),
                        weight: Yup.string().required("This Value is Required"),
                        pieces: Yup.string().required("This Value is Required"),
                        fromDeliverBoyId: Yup.string().required(
                          "This Value is Required"
                        ),
                        selfInternalremarks: Yup.string()
                          .max(512)
                          .required("This Value is Required"),
                      })}
                      onSubmit={async values => {}}
                    >
                      {({ errors, status, touched, values }) => (
                        <Form className="needs-validation">
                          <Row>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="stockID"
                                className="col-lg-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Stock ID")}
                                </h5>
                              </Label>
                              <div className="col-lg-7 col-12">
                                <Field
                                  className={
                                    "form-control fs-5 text-uppercase" +
                                    (errors.stockID && touched.stockID
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled
                                  type="text"
                                  name="stockID"
                                  value={
                                    this.state.props.isEdit ||
                                    this.state.props.isView
                                      ? this.state.props.data.id
                                      : this.state.jangadId
                                  }
                                />
                                <ErrorMessage
                                  name="stockID"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="partyId"
                                className="col-lg-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Party Name")}
                                </h5>
                              </Label>
                              <div className="col-lg-7 col-12">
                                <Field
                                  className={
                                    "form-control form-select fs-5" +
                                    (errors.partyId && touched.partyId
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name="partyId"
                                  as="select"
                                  disabled={
                                    this.state.props.isView ? true : false
                                  }
                                >
                                  <option value="" disabled>
                                    select
                                  </option>
                                  {this.state.partyList?.map(x => (
                                    <option key={x.id} value={x.id}>
                                      {x.name}
                                    </option>
                                  ))}
                                </Field>
                                <ErrorMessage
                                  name="partyId"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="factoryId"
                                className="col-lg-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Unit Name")}
                                </h5>
                              </Label>
                              <div className="col-lg-7 col-12">
                                <Field
                                  className={
                                    "form-control form-select fs-5" +
                                    (errors.factoryId && touched.factoryId
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name="factoryId"
                                  as="select"
                                  disabled={
                                    this.state.props.isView ? true : false
                                  }
                                >
                                  <option value="" disabled>
                                    select
                                  </option>
                                  {this.state.factoryList?.map(x => (
                                    <option value={x.id} key={x.id}>
                                      {x.name}
                                    </option>
                                  ))}
                                </Field>
                                <ErrorMessage
                                  name="factoryId"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="weight"
                                className="col-lg-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Total Weight")}
                                </h5>
                              </Label>
                              <div className="col-lg-7 col-12">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.weight && touched.weight
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="number"
                                  onWheel={e => e.target.blur()}
                                  name="weight"
                                  placeholder="20.25 CT"
                                  disabled={
                                    this.state.props.isView ? true : false
                                  }
                                />
                                <ErrorMessage
                                  name="weight"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="pieces"
                                className="col-lg-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Total No of pieces")}
                                </h5>
                              </Label>
                              <div className="col-lg-7 col-12">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.pieces && touched.pieces
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="number"
                                  onWheel={e => e.target.blur()}
                                  name="pieces"
                                  placeholder="No. of peices"
                                  disabled={
                                    this.state.props.isView ? true : false
                                  }
                                />
                                <ErrorMessage
                                  name="pieces"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="fromDeliverBoyId"
                                className="col-lg-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Delivery Boy Name")}
                                </h5>
                              </Label>
                              <div className="col-lg-7 col-12">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.fromDeliverBoyId &&
                                    touched.fromDeliverBoyId
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name="fromDeliverBoyId"
                                  as="select"
                                  disabled={
                                    this.state.props.isView ? true : false
                                  }
                                >
                                  <option value="" disabled>
                                    select
                                  </option>
                                  {this.state.deliveryBoyList?.map(x => (
                                    <option key={x.id} value={x.id}>
                                      {x.name}
                                    </option>
                                  ))}
                                </Field>
                                <ErrorMessage
                                  name="fromDeliverBoyId"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>

                            <div className="mb-3 row">
                              <Label
                                htmlFor="selfInternalRemarks"
                                className="col-lg-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Self Internal Remarks")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.selfInternalRemarks &&
                                    touched.selfInternalRemarks
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="selfInternalRemarks"
                                  as="textarea"
                                  rows="5"
                                  disabled={
                                    this.state.props.isView ? true : false
                                  }
                                />
                                <ErrorMessage
                                  name="selfInternalRemarks"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="col-md-12 text-end">
                              {this.state.props.isView ? (
                                <>
                                  <Link to="/user-office-stock-list">
                                    <Button
                                      color="primary"
                                      className="fs-4 px-5 no-print"
                                      type="submit"
                                    >
                                      Back
                                    </Button>
                                  </Link>
                                  <Button
                                    onClick={e =>
                                      window.print(e.preventDefault())
                                    }
                                    color="success"
                                    className="fs-4 ms-2 no-print"
                                    type="submit"
                                  >
                                    <img
                                      src="images/dashboard-images/printwhite.svg"
                                      alt="print"
                                    />
                                  </Button>{" "}
                                </>
                              ) : (
                                <Button
                                  color="primary"
                                  className="fs-4 px-5"
                                  type="submit"
                                  onClick={() => {
                                    this.handleSubmit(event, values);
                                  }}
                                >
                                  Submit
                                </Button>
                              )}
                            </div>
                          </Row>
                        </Form>
                      )}
                    </Formik>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default withTranslation()(UserEditInwardStock);
